import { mergeMap, tap } from 'rxjs/operators';
import { delay, distinctUntilChanged, skip, filter, take, map } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import { AppState } from '../../reducers';
import { selectscoringRecordsInStore, selectscoringRecordsPageLoading, selectscoringRecordsShowInitWaitingMessage } from '../_selectors/scoringRecord.selectors';


export class ScoringRecordDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
        super();

		this.loading$ = this.store.pipe(
			select(selectscoringRecordsPageLoading),
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectscoringRecordsShowInitWaitingMessage)
        );
        
        this.store.pipe(
			select(selectscoringRecordsInStore),
		).subscribe((response: QueryResultsModel) => {
			this.paginatorTotalSubject.next(response.totalCount);
			this.entitySubject.next(response.items);
		});

    }
}